import { render, staticRenderFns } from "./checkPassword.vue?vue&type=template&id=06acc2d2&scoped=true&"
import script from "./checkPassword.vue?vue&type=script&lang=js&"
export * from "./checkPassword.vue?vue&type=script&lang=js&"
import style0 from "./checkPassword.vue?vue&type=style&index=0&id=06acc2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06acc2d2",
  null
  
)

component.options.__file = "checkPassword.vue"
export default component.exports